import Utils from '../common/Utils';
import {boardOption, commentOption, listOption} from "./Config";

class App {
  boardInfo = {
    list : ui.ncCommunity.List,
    view : ui.ncCommunity.View,
    write : ui.ncCommunity.Write,
    comment : ui.ncCommunity.Comment,
    myBookMark : ui.ncCommunity.MyBookmark,
    myBoard : ui.ncCommunity.MyArticle,
    myComment : ui.ncCommunity.MyComment,
    $list: $('#ncCommunityList'),
    $view: $('#ncCommunityView'),
    $write: $('#ncCommunityWrite'),
    $comment: $('#ncCommunityComment'),
    $myBookMark : $('#ncCommunityList'),
    $myBoard : $('#ncCommunityList'),
    $myComment : $('#ncCommunityList')
  }

  constructor(_config = {}, _commentConfig = null) {
    this.config = Object.assign({}, _config);
    this.boardOption = boardOption(this.config );
    this.commentOption = {};
    if(_commentConfig)this.commentOption = commentOption(_commentConfig);
   // console.log(this.boardOption)
    this.init();
  }

  init() {
    const board = new this.boardInfo[this.config.boardType]( this.boardInfo['$'+this.config.boardType], this.boardOption);
    let boardUrl = null;
    switch (this.config.boardType) {
      case 'myBookMark':
        boardUrl = window._path + 'board/_my_/scrapArticle/search/moreScrapArticle?serverId=' + this.config.serverId //+ '&serverType=' + this.config.serverType;
        break;
      case 'myBoard':
        boardUrl = window._path + 'board/_user_/article/search/moreArticle?serverId=' + this.config.serverId + '&characterName=' + encodeURI(this.config.characterName) //+ '&serverType=' + this.config.serverType;
        break;
      case 'myComment':
        boardUrl = window._path + 'board/_user_/commentedArticle/search/moreCommentedArticle?serverId=' + this.config.serverId + '&characterName=' + encodeURI(this.config.characterName) //+ '&serverType=' + this.config.serverType;
        break;
      case 'view' :
        board.onLoaded.add( ()=>{
          if(!this.boardOption.isComment)return;
          if(this.boardOption.checkCategoryId && this.boardOption.checkCategoryId != document.cookie.match('(^|;) ?' + 'board_categoryId' + '=([^;]*)(;|$)')[2])return;
          if(this.config.board != 'update' && this.config.board != 'library'){
            const comment = new this.boardInfo.comment( this.boardInfo.$comment, this.commentOption);
            comment.get();
          }
        });
        break;
      case 'write':
        return;
        break;

    }
     $('.contents-wrapper .contents').addClass(this.config.board)
     board.get(boardUrl);
  }
}

Utils.namespace('nc.bns.community');
nc.bns.community = App;

